import buildTagging from './tagging';

const React = require('react');
const CheckBox = require('components/checkBox/checkBox');
const { InputText } = require('components/inputText/inputText');
import { formatText } from 'core/i18n';
import { PATRIMONY_OPTIONS } from './constants';

const validator = require('validator');
const { useMaxLength } = require('hooks/useMaxLength');

const Patrimony = ({ userProfile, userProfileForm, formActions, disabled, handleSave }) => {
    const tagging = buildTagging();
    const inputMaxLength = 40;
    const { amendInputValue } = useMaxLength(inputMaxLength);
    const capital = {
        work: typeof userProfile['capital_work'] !== 'undefined' ? userProfile['capital_work'] : false,
        activities:
            typeof userProfile['capital_activities'] !== 'undefined' ? userProfile['capital_activities'] : false,
        heritage: typeof userProfile['capital_heritage'] !== 'undefined' ? userProfile['capital_heritage'] : false,
        business: typeof userProfile['capital_business'] !== 'undefined' ? userProfile['capital_business'] : false,
        realState: typeof userProfile['capital_realState'] !== 'undefined' ? userProfile['capital_realState'] : false,
        gamesOfChance:
            typeof userProfile['capital_gamesOfChance'] !== 'undefined' ? userProfile['capital_gamesOfChance'] : false,
        other:
            typeof userProfile['capital_description'] !== 'undefined' && userProfile['capital_description'] !== ''
                ? userProfile['capital_description']
                : null,
    };

    const handleDataToSave = (name, value) => {
        capital[name] = value;
        handleSave('capital', capital);
    };

    const handleClickOther = value => {
        if (!value) {
            formActions.change('userProfile.capital_description', '');

            capital['other'] = null;
            formActions.setValidity('userProfile.capital_description', { required: true });
            handleSave('capital', capital);
        }
    };

    const handleChange = (dataChanged, value) => {
        tagging.doTagChangePatrimonyIncome(dataChanged.key);
        if (dataChanged.value === PATRIMONY_OPTIONS.OTHER.onChangeData.value) return handleClickOther(value);

        return handleDataToSave(dataChanged.value, value);
    };

    const generatedData = Object.keys(PATRIMONY_OPTIONS).map(key => ({
        label: formatText(PATRIMONY_OPTIONS[key].label),
        model: PATRIMONY_OPTIONS[key].model,
        onChange: value => handleChange(PATRIMONY_OPTIONS[key].onChangeData, value),
        errorMessageComponent: PATRIMONY_OPTIONS[key].errorMessageComponent,
    }));

    const handleOnKeyUp = event => {
        amendInputValue(event.target);
    };

    const buildExtraField = (model, otherLabel) => {
        if (!userProfile['capital_other']) return;

        return (
            <div className="other-input">
                <InputText
                    onKeyUp={handleOnKeyUp}
                    maxLength={inputMaxLength}
                    profileModel={model}
                    label={otherLabel}
                    userProfile={userProfile}
                    userProfileForm={userProfileForm}
                    formActions={formActions}
                    validations={{
                        required: value => value && value.length,
                        valid: value =>
                            validator.matches(value, /^[a-zA-ZÀ-ÄÇ-ÏÑ-ÖÙ-Üà-äç-ïñ-öù-ü\s]*$/) && value.length <= 40,
                    }}
                    messagesError={{
                        required: formatText('validation-fieldRequired'),
                        valid: formatText('validation-syntaxError'),
                    }}
                    isValidated={function () {
                        const modelName = model.split('.')[1];
                        capital['other'] = userProfile[modelName];

                        handleSave('capital', capital);
                    }}
                    disabled={disabled}
                    focusAnimated
                />
            </div>
        );
    };

    return (
        <div>
            <label>{formatText('field-hasPublicOfficePatrimony')}</label>
            <label className="sub-label">{formatText('field-checkMoreThanOne')}</label>
            <CheckBox
                profileModel={'userProfile.is_patrimony'}
                fieldsRequired="1"
                checkBoxList={generatedData}
                userProfile={userProfile}
                userProfileForm={userProfileForm}
                formActions={formActions}
                focusAnimated
                disabled={disabled}
                checkBoxListErrorMessage={formatText('validation-fieldRequired')}
            />
            {buildExtraField('userProfile.capital_description', formatText('field-otherCapital'))}
        </div>
    );
};

React.propTypes = {};

React.defaultProps = {};

module.exports = Patrimony;
